import {
  Record,
  String as RTString,
  Boolean as RTBoolean,
  Static,
  Array as RTArray
} from 'runtypes';
import { DeepPartial } from 'utility-types';
import { buildService } from './decorated-service';

const AddressValidationService = buildService(
  '/nasu-svc/service/validation/address'
);

const CreateAddressValidationArgs = RTArray(
  Record({
    city: RTString,
    country: RTString,
    state: RTString,
    street1: RTString,
    street2: RTString,
    street3: RTString,
    usaddress: RTBoolean,
    zip: RTString
  })
);

export type StaticPostAddressValidationArgs = Static<
  typeof CreateAddressValidationArgs
>;

export const postAddressValidation = (
  args: DeepPartial<StaticPostAddressValidationArgs>
): Promise<any> => {
  const validated: StaticPostAddressValidationArgs = CreateAddressValidationArgs.check(
    args
  );
  return AddressValidationService.add(validated, {
    ignoreServiceFailure: true
  });
};
